
export const MuiCheckbox = {
    styleOverrides: {
        root: {
            color: 'var(--mui-palette-primary-main)',
        }
    }
}
